import React from 'react';

const PencilIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 20h4l10-10-4-4L4 16v4z" />
        <path d="M13.5 6.5l4 4" />
    </svg>
);

// Просто текст з конфігурації в картці з дизайну. Значення не має і onChange не викликає.
const InfoBox = (props) => (<div className="info-box">
    <PencilIcon />
    <p dangerouslySetInnerHTML={{ __html: props.text }} />
</div>);

export default InfoBox;
